import React, { Fragment, useState, useEffect } from 'react';
import Button from "../../../Button";
import { Controller, useForm } from 'react-hook-form';
import DatePicker from "react-datepicker";
import styles from "../ShippingForm/ShippingForm.module.sass";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const Form = ({ closeModal}) => {
  const { register, handleSubmit, control, trigger, watch, setValue, unregister, formState: { errors } } = useForm();
  const watchItemNumber = watch("order_package_id");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = (data) => {
    const date  = new Date();

    axios
      .post(`/api/v1/orders/reprint_item`,
        { item:
            { id: data.order_package_id }
        })
      .then(() => {
        sendToastMessage(data.order_package_id);
        setValue('order_package_id', undefined);})
      .catch((error) => {
        sendFailToastMessage(error, data.order_package_id)
      });
  }

  const sendToastMessage = (item_id) => {
    toast.success(`Item #${item_id} successfully marked to be reprinted`, {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  const sendFailToastMessage = (error, item_id) => {
    const message = error && error.response && error.response.data.errors || `Item #${item_id} was not marked as reprinted. Please try again or check the item number`
    toast.error(message , {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  return (
    <Fragment>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <label className={styles.label}>Item Number</label>
        <input
          className={styles.input}
          {...register("order_package_id", { required: true })}
        />

        <Button
          classes={styles.submit}
          fullWidth
          variant='submit'
          disabled={!watchItemNumber || isSubmitting}
        >
          Submit
        </Button>
      </form>
    </Fragment>
  )
}

export default Form;
